import clsx from "clsx";

type SkeletonProps = {
  hasContent?: boolean;
  className?: string;
};

const Skeleton = ({ hasContent = true, className }: SkeletonProps) => {
  return (
    <div className="flex animate-pulse flex-col gap-3">
      <div
        className={clsx("h-48 rounded-xl bg-secondTextColor/20", className)}
      />
      {hasContent && (
        <>
          <div className="bg-secondTextColor/20 h-2 rounded" />
          <div className="bg-secondTextColor/20 h-6 rounded" />
        </>
      )}
    </div>
  );
};

export default Skeleton;
